export interface ScratchGameParams {
    gameId: number;
    userIdentity: string;
}

export enum ScratchGameActions {
    Scratched = "SCRATCH",
    Notification = "NOTIFICATION",
}

export interface NotifyGameScratchedParams {
    resultId: number;
}

export interface SendWinnerDataParams {
    resultId: number;
    dpa: boolean;
    email: string;
}
